import React from 'react';
import {NavLink} from "react-router-dom";

import infoIcon from "components/assets/images/app-info.svg";
import "./InfoButton.css";

/**
 * Infobutton - button active when main-menu is open
 */
export default class InfoButton extends React.Component {
  render() {
    return (
      <NavLink
        to="/info/"
        className="app-info-button"
        activeClassName={`app-info-button--selected`}>
          <img className="app-info-button__icon" src={infoIcon} alt="" />
      </NavLink>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/app/bar/InfoButton.js